import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseUpdatePublicCompanyLeadContractFee {
  publicCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdatePublicCompanyLeadContractFee = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseUpdatePublicCompanyLeadContractFee) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updatePublicCompanyLeadContractFee'],
    mutationFn: async (data: { id: string; value?: string; main_fee?: boolean }) => {
      const lead = {
        contract_attributes: {
          contract_fees_attributes: data,
        },
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
